module.exports = __webpack_public_path__ + "img/mono-square.94f40017.svg";